import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import Watch from "@/pages/Watch";
import Account from "@/pages/Account";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SubscribePage from "@/pages/Subscribe";
import AuthCallback from "@/components/AuthCallback";
import ExpiredBanner from "@/components/ExpiredBanner";

function AppRouter() {
  const location = useLocation();
  // Handle Emergent Google OAuth return: #session_id=XXX must be processed
  // before any other route renders (synchronous check prevents race conditions).
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  const showBanner = !location.pathname.startsWith("/admin");
  return (
    <>
      {showBanner && <ExpiredBanner />}
      <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/subscribe" element={<SubscribePage />} />
      <Route path="/browse" element={<Browse />} />
      <Route path="/watch/:id" element={<Watch />} />
      <Route path="/account" element={<Account />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
      <Route path="*" element={<Landing />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
